import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const BomViewModule = new Module({
  id: 'BOM:VIEW:RESULT-TABLE',
  name: 'BOM',
  label: 'BOM',
  path: 'bom',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/BOM/View'))
  ),
  actions: {
    edit: {
      id: 'BOM:VIEW:*',
      name: 'VIEW',
      label: 'View'
    },
    delete: {
      id: 'bom-delete',
      name: 'delete',
      label: 'Delete'
    },
    process: {
      id: 'BOM-PROCESS:VIEW:*',
      name: 'Process',
      label: 'Process'
    }
  }
});

export const BomAddModule = new Module({
  id: 'BOM:ADD:*',
  name: 'bomAdd',
  path: 'bom/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/BOM/Form'))
  ),
  actions: {
    add: {
      id: 'BOM:ADD:*',
      name: 'BOM Add',
      label: 'Add BOM'
    }
  }
});

export const BomEditModule = new Module({
  id: 'BOM:VIEW:DETAILS',
  name: 'BOM Edit',
  path: 'bom/details/:bomId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/BOM/Form'))
  )
});

// export const ItemProcessViewModule = new Module({
//   id: 'ITEM-PROCESS:VIEW:*',
//   name: 'Item Process View',
//   path: 'item/process',
//   pathDef: 'item/process/:id',
//   Component: ComponentLoader(
//     lazy(() => import('src/content/management/Items/ProcessView'))
//   )
// });

const BomModules = [
  BomViewModule,
  BomAddModule,
  BomEditModule,
  // ItemProcessViewModule
];

export default new ModuleBundle('BOM', BomModules);
